/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Scene_Change_Detection_Failed_ToastInputs */



/**
* | output |
* | --- |
* | "Failed to detect shot changes. {error}" |
*
* @param {Scene_Change_Detection_Failed_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const scene_change_detection_failed_toast = /** @type {((inputs: Scene_Change_Detection_Failed_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Scene_Change_Detection_Failed_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Echec de la detection des changements de plan. ${i?.error}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Schusswechsel konnten nicht erkannt werden. ${i?.error}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Impossibile rilevare i cambi di tiro. ${i?.error}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Не удалось обнаружить изменения в выстреле. ${i?.error}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`No se pudieron detectar cambios en la toma. ${i?.error}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`未能检测到投篮变化。${i?.error}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`ショットの変更を検出できませんでした。${i?.error}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`शॉट में हुए बदलावों का पता लगाने में विफल। ${i?.error}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Falha na detecção de alterações de disparo. ${i?.error}`)
	return /** @type {LocalizedString} */ (`Failed to detect shot changes. ${i?.error}`)
});